export class CustomerCreditStatusRequest {
  constructor(
    public fiscalId: string,
    public fiscalIdType: string,
    public branchCode: string,
    public sellerCode: string,
    public menu: string
  ) {}
}
